import { action, createAction, createStandardAction } from 'typesafe-actions'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import { UpdateProject_updateProject } from '@chegg-wt/core/queries/UpdateProject'
import { FetchProject_project } from '@chegg-wt/core/queries/FetchProject'
import { Project } from '@chegg-wt/core/types/core'
import { FetchCitationsPayload } from '../bibliography/types'
import { ActionTypes } from './constants'
import { CreateProjectPayload } from './types'

export const createProject = createAction(ActionTypes.CREATE_PROJECT, (action) => {
  return (citationData?: CreateProjectPayload) => action(citationData)
})

export const editCitationStyle = (styleId: string) =>
  action(ActionTypes.EDIT_CITATION_STYLE_REQUEST, { styleId })

export const editCitationStyleFailed = createErrorAction(
  ActionTypes.EDIT_CITATION_STYLE_ERROR
)

export const setCurrentProject = createStandardAction(ActionTypes.SET_CURRENT_PROJECT)<
  Project | FetchProject_project | UpdateProject_updateProject
>()

export const setCurrentProjectStyleName = (styleName: string) =>
  action(ActionTypes.SET_STYLE_NAME, { styleName })

export const setUrlStyleName = (urlStyleName: string) =>
  action(ActionTypes.SET_URL_STYLE_NAME, { urlStyleName })

export const fetchCurrentProjectStyleName = (style: string) =>
  action(ActionTypes.FETCH_PROJECT_STYLE_NAME, { style })

export const fetchUrlStyleName = (style: string) =>
  action(ActionTypes.FETCH_URL_STYLE_NAME, { style })

export const clearCurrentProject = createStandardAction(
  ActionTypes.CLEAR_CURRENT_PROJECT
)()

export const setCurrentProjectInProgress = createStandardAction(
  ActionTypes.SET_CURRENT_PROJECT_IN_PROGRESS
)<{ status: boolean }>()

export const fetchCurrentProject = createStandardAction(
  ActionTypes.FETCH_CURRENT_PROJECT
)<FetchCitationsPayload>()

export const fetchProjectError = createErrorAction(
  ActionTypes.FETCH_CURRENT_PROJECT_ERROR
)

export const fetchProjectStyleNameError = createErrorAction(
  ActionTypes.FETCH_CURRENT_PROJECT_STYLE_NAME_ERROR
)

export const fetchUrlStyleNameError = createErrorAction(
  ActionTypes.FETCH_URL_STYLE_NAME_ERROR
)

export const styleSelected = (
  style: string,
  skipSoftGate?: boolean,
  allowStyleChange?: boolean,
  redirect?: boolean
) =>
  action(ActionTypes.STYLE_SELECTED, {
    style,
    skipSoftGate,
    allowStyleChange,
    redirect,
  })

/**
 * invoke softGateStyle modal
 * @param {String} style - If no style is passed, default allowed style is used
 */
export const softGateStyle = (style?: string, redirect = true, callbackFn?: () => any) =>
  action(ActionTypes.SOFT_GATE_STYLE, { style, redirect, callbackFn })

export const setGenerateNewCitationList = (generateNewCitationList?: boolean) =>
  action(ActionTypes.GENERATE_NEW_CITATION_LIST, { generateNewCitationList })

export const checkProjectExpiration = createStandardAction(ActionTypes.CHECK_EXPIRATION)()

export const setAsCurrentProject = (projectId: string) =>
  action(ActionTypes.SET_AS_CURRENT_PROJECT, { projectId })
